import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CoreConfigService } from "../../../../../../../@core/services/config.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { AuthenticationService, UserService } from "../../../../../../auth/service";
import moment from "moment";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-document-preview",
  templateUrl: "./document-preview.component.html",
  styleUrls: ["./document-preview.component.scss"],
})
export class DocumentPreviewComponent implements OnInit {
  public text: any;

  public pages: any;

  public currentUser: any;

  public me: ICurrentUser;

  constructor(
    public route: ActivatedRoute,
    private _coreConfigService: CoreConfigService,
    private _domSanitizer: DomSanitizer,
    public _authenticationService: AuthenticationService,
    public _userService: UserService,
  ) {
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  async ngOnInit() {
    this.me = this._authenticationService.getCurrentUser();
    this.currentUser = await this._userService.get(this.me.hash);

    this.text = JSON.parse(localStorage.getItem("textEditor")); //Prendo la preview dal local storage

    this.text = this.text.replace(/DATA_OGGI/gi, moment().format("DD/MM/YYYY"));

    this.currentUser.title = this.currentUser.sex === "m" ? "Sig." : "Sign.ra";
    this.currentUser.to_title = this.currentUser.sex === "m" ? "Al" : "Alla";
    this.currentUser.sex = this.currentUser.sex === "m" ? "maschile" : this.currentUser.sex === "f" ? "femminile" : "altro";

    Object.keys(this.currentUser.contract).forEach((key: string) => {
      const reg: RegExp = new RegExp(`USER_CONTRACT_${key.toUpperCase()}`, "gi");
      this.text = this.text.replace(reg, moment(this.currentUser.contract[key]).format("DD-MM-YYYY"));
    });

    Object.keys(this.currentUser).forEach((key: string) => {
      if (key === "birthday" && this.currentUser.birthday) {
        this.currentUser.birthday = moment(this.currentUser.birthday).format("DD-MM-YYYY");
      }
      const reg: RegExp = new RegExp(`USER_${key.toUpperCase()}`, "gi");
      this.text = this.text.replace(reg, this.currentUser[key]);
    });

    Object.keys(this.currentUser.addresses.residenza).forEach((address: string) => {
      const reg: RegExp = new RegExp(`ADDRESS_${address.toUpperCase()}`, "gi");
      this.text = this.text.replace(reg, this.currentUser.addresses.residenza[address]);
    });

    Object.keys(this.currentUser.contract).forEach(() => {
      const reg: RegExp = new RegExp("null", "gi");
      this.text = this.text.replace(reg, "...................");
    });

    this.text = this.text.replace("USER_RESIDUAL_HOLIDAY", 15);
  }

  transform(html: string): SafeHtml {
    return this._domSanitizer.bypassSecurityTrustHtml(html);
  }
}
